import { render, staticRenderFns } from "./ListV2.vue?vue&type=template&id=e9491f88&scoped=true&"
import script from "./ListV2.vue?vue&type=script&lang=js&"
export * from "./ListV2.vue?vue&type=script&lang=js&"
import style0 from "./ListV2.vue?vue&type=style&index=0&id=e9491f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9491f88",
  null
  
)

export default component.exports